/**
 * Present when the corresponding menubar is modal.
 */
export const modal = 'data-modal';
/**
 * Determines the orientation of the menubar.
 * @type {'horizontal' | 'vertical'}
 */
export const orientation = 'data-orientation';
/**
 * Present when any submenu within the menubar is open.
 */
export const hasSubmenuOpen = 'data-has-submenu-open';
